<template>
  <app-page-container title="لیست کد ها">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="2" class="mr-n3">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab small dark @click="getListOfPhonesActivityReport" class="darkColor mt-3" v-bind="attrs"
              v-on="on">
              <v-icon color="white">mdi-refresh mdi-18px</v-icon>
            </v-btn>
          </template>
          <span>بروزرسانی لیست کد ها</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main mx-2">
        <v-col cols="12">
          <v-card elevation="0" class="body-card card-width pa-0">
            <v-card-text class="pa-0">
              <v-row no-gutters>
                <v-col cols="12">
                  <template>
                    <v-data-table fixed-header hide-default-header multi-sort hide-default-footer height="67vh"
                      class="elevation-0 tt" :headers="ambulance800ListTableHeader"
                      :items="listOfCodesFor800AmbulanceList" :items-per-page="listOfCodesFor800AmbulanceList.length"
                      :search="searchTitle">
                      <template v-slot:header="props">
                        <app-group-table-header :headers="props.props.headers" @sort="props.on.sort"
                          @group="props.on.group" />
                      </template>
                      <template v-slot:[`item.row`]="{ index }">
                        <div>
                          {{ index + 1 }}
                        </div>
                      </template>
                      <template v-slot:[`item.icon`]="{ item }">
                        <v-tooltip top v-if="item.hasMission">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-n1" color="#F56060" style="cursor: pointer" v-bind="attrs" v-on="on">
                              mdi-car-emergency mdi-18px
                            </v-icon>
                          </template>
                          <span>در حال ماموریت</span>
                        </v-tooltip>
                        <v-tooltip top v-if="!item.hasMission">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-n1" color="#3BCA79" style="cursor: pointer" v-bind="attrs" v-on="on">
                              mdi-car-off mdi-18px
                            </v-icon>
                          </template>
                          <span>بدون ماموریت</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1" color="iconColor" style="cursor: pointer" v-bind="attrs"
                              @click="callToCode(item.phoneNumber)" v-on="on">
                              mdi-phone
                            </v-icon>
                          </template>
                          <span>تماس</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                              @click="showMoreDataModel(item)" v-bind="attrs" v-on="on">
                              mdi-information
                            </v-icon>
                          </template>
                          <span>جزئیات</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <v-dialog v-model="moreInfoModel" width="700" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-col cols="1"></v-col>
                  <v-spacer></v-spacer>
                  <span class="modal-title-text">کد {{ missionPhoneCode }}</span>
                  <v-spacer></v-spacer>
                  <v-col cols="1" class="text-left ml-2">
                    <v-icon color="#212121" @click="closeMoreInfoModal()">mdi-close</v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-5">
              <v-row>
                <span>کاربران</span>
                <v-divider class="mt-3 mr-2"></v-divider>
              </v-row>
              <v-row no-gutters class="mt-4">
                <v-col cols="12" v-for="item in moreInfoData" :key="item.id">
                  <v-card class="detail-more-info-card" elevation="0">
                    <v-row>
                      <span v-if="item.status" class="more-info-status">
                        <v-icon color="#3BCA79" class="ml-1">mdi-wifi mdi-18px</v-icon>
                        آنلاین
                      </span>
                      <span v-else class="more-info-status2">
                        <v-icon color="#F56060" class="ml-1">mdi-wifi-off mdi-18px</v-icon>
                        آفلاین
                      </span>
                    </v-row>
                    <v-card-text class="mt-7">
                      <v-row>
                        <v-col class="mt-n7" cols="6" v-for="(info, index) in item.info" :key="index">
                          <user-detail-component :icon="info.icon" :title="info.title" :text="info.value"
                            :size="info.size"></user-detail-component>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </section>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
      </section>
    </template>
  </app-page-container>
</template>
<script>
import AppGroupTableHeader from '@/components/app/table/groupableHeader.vue';
import AlertComponent from '@/components/AlertComponent.vue';
import UserDetailComponent from '@/components/UserDetailComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import PhoneMixin from '@/Mixins/BaseInformation/PhoneMixin';
import CallMixin from '@/Mixins/Call/CallMixin';
import Ambulance800ListHelper from '@/Helpers/800/Ambulance800ListHelper';
import UserNotificationMixin from '@/Mixins/800/userNotification.mixin';
export default {
  name: 'Ambulance800List',
  title: 'لیست کدها',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    UserDetailComponent,
    AppPageContainer,
    AppGroupTableHeader,
  },
  mixins: [
    ShearedMixin,
    PhoneMixin,
    Ambulance800ListHelper,
    snackBar,
    ShearedHelper,
    CallMixin,
    UserNotificationMixin,
  ],
  created() {
    this.$root.$refs.Ambulance800List = this;
    this.$mainSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
  },
  beforeDestroy() {
    this.$mainSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);

    delete this.$root.$refs.Ambulance800List;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.getListOfPhonesActivityReport();
    },
    fNotifyOutOfService: function (data) {
      switch (data?.type) {
        case 1:
          this.showTostMessage2(data?.text, 'ambulance107s', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        case 2:
          this.showTostMessage2(data?.text, '', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        default:
          break;
      }
      this.onGetAllUserNotificationOnSignal();
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

.detail-more-info-card {
  border: 1px solid var(--dark-color) !important;
  border-radius: 13px !important;
}

.more-info-status {
  color: #3bca79 !important;
  position: absolute;
  margin-right: 40px !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  background: white !important;
}

.more-info-status2 {
  color: #f56060 !important;
  position: absolute;
  margin-right: 40px !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  background: white !important;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
